var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-input',{staticClass:"input-field",attrs:{"value":_vm.value,"placeholder":_vm.placeholder,"autocomplete":"on","disabled":_vm.disabled},on:{"input":_vm.updateValue,"focus":_vm.onFocus}})}
var staticRenderFns = []

export { render, staticRenderFns }